/**
 * Mobile shell is opt-in via NUXT_PUBLIC_MOBILE_ENABLED.
 * Default: desktop UI for everyone (including phones).
 */
export default function useMobileShell() {
  const { isMobile } = useDevice();
  const { public: runtimePublic } = useRuntimeConfig();

  const mobileEnabled = computed(() => {
    const value = runtimePublic.mobileEnabled;

    return value === true || String(value) === 'true';
  });

  const isMobileShell = computed(() => mobileEnabled.value && Boolean(unref(isMobile)));

  return {
    mobileEnabled,
    isMobileShell,
  };
}
